<template>
  <v-layout class="contact pa-3" align-space-around justify-center fill-height>
    <v-flex class="pa-0 ma-0" xs12 md6>
      <h1>{{ $t("contact.title") }}</h1>
      <v-snackbar v-model="snackbar" :timeout="4000" :color="snackbarColor">
        <span> {{ snackbarText }}</span>
        <v-btn color="white" flat @click="snackbar = false">{{ $t("close")}}</v-btn>
      </v-snackbar>
      <v-form ref="form" v-model="valid" class="px-3">
        <v-text-field
          :label="nameSurname"
          name="name"
          v-model="name"
          :rules="nameRules"
          required
          prepend-icon="person"
        ></v-text-field>
        <v-text-field
          :label="ctEmail"
          name="email"
          v-model="email"
          :rules="emailRules"
          required
          prepend-icon="email"
        ></v-text-field>
        <v-textarea
          :label="ctContent"
          name="message"
          v-model="content"
          :rules="contentRules"
          required
          :counter="500"
          prepend-icon="edit"
        ></v-textarea>
        <v-btn
          :loading="loading"
          :disabled="!valid"
          @click="validate"
          flat
          large
          dark
          class="primary mx-0 mt-3"
          :block="block"
          >{{ $t("contact.send") }}
          <v-icon class="pl-3">fa-paper-plane</v-icon>
        </v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
import { fcn } from "../../fb";

export default {
  data() {
    return {
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      valid: true,
      content: "",
      contentRules: [],
      name: "",
      nameRules: [],
      email: "",
      emailRules: [],
      loader: null,
      loading: false,
      snackbarText: "",
      snackbarColor: "primary",
      snackbar: false,
      nameSurname: "",
      ctEmail: "",
      ctContent: "",
      formSentSuccess: "",
      formSentFailure: ""
    };
  },
  methods: {
    submit() {
      this.loading = true;
      const sendMail = fcn.httpsCallable("sendMail");
      sendMail({ email: this.email, message: this.content, name: this.name })
        .then(result => {
          console.log(result);
          this.loading = false;
          this.snackbarColor = "success";
          this.snackbarText = this.formSentSuccess;
          this.snackbar = true;
          this.reset();
        })
        .catch(error => {
          console.error(error);
          this.snackbarColor = "error";
          this.snackbarText = this.formSentFailure;
          this.snackbar = true;
          this.loading = false;
        });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.submit();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  },
  computed: {
    block() {
      return this.$vuetify.breakpoint.name === "xs";
    }
  },
  created() {
    console.log("CREATED");
    this.emailRules = [
      v => !!v || this.$t("contact.required"),
      v => this.reg.test(v) || this.$t("contact.validEmail")
    ];
    this.contentRules = [
      v => !!v || this.$t("contact.required"),
      v => (v && v.length >= 10) || this.$t("contact.validContentMin"),
      v => (v && v.length <= 500) || this.$t("contact.validContentMax")
    ];
    this.nameRules = [
      v => !!v || this.$t("contact.required"),
      v => (v && v.length >= 3) || this.$t("contact.validNameMin"),
      v => (v && v.length <= 30) || this.$t("contact.validNameMax")
    ];
  },
  beforeUpdate() {
    this.resetValidation();
  },
  updated() {
    this.nameSurname = this.$t("contact.nameSurname");
    this.ctEmail = this.$t("contact.email");
    this.ctContent = this.$t("contact.content");
    this.formSentSuccess = this.$t("contact.formSentSuccess");
    this.formSentFailure = this.$t("contact.formSentFailure");
  }
};
</script>
<style>
.contact {
  background: var(--background);
  /*height: 800px;*/
}

/*button.v-btn[disabled] {*/
/*    opacity: 0.6;*/
/*}*/
</style>
